import React, { useState, useEffect } from "react";

import classNames from "classnames";

import { loadImage } from "../../../utils/common";
import * as styles from "./LazyImage.module.scss";

interface LazyImageProps {
  src: any;
  alt: string;
  defaultAspectRatio?: number;
  props?: object;
}

const LazyImage: React.FC<LazyImageProps> = ({
  src,
  alt = "",
  defaultAspectRatio = 1,
  ...props
}) => {
  const [loaded, setLoaded] = useState();

  useEffect(() => {
    let setter = true;

    loadImage(src).then(() => {
      if (setter) {
        window.dispatchEvent(
          new Event("tile-loaded", {
            bubbles: true,
          }),
        );
        setLoaded(src);
      }
    });

    return () => (setter = false);
  }, [src]);
  return (
    <span
      className={classNames(
        styles.image,
        { [styles.loaded]: loaded },
        "lazy-image",
      )}
      style={{ "--lazy-image-aspect": `${defaultAspectRatio * 100}%` }}
    >
      <img src={loaded} loading="lazy" alt={alt} {...props} />
    </span>
  );
};

export { LazyImage };
